export const fetch_Api_Details_Start = (fetching_Start) => ({
    type: fetching_Start,
})
export const fetch_Api_Details_Fail = (fetching_Fail, error) => ({
    type: fetching_Fail,
    payload: error
})